module.exports = __webpack_public_path__ + "static/img/1_0_1.3b71bba8.jpg";